import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_USEFUL_LINK_GROUP = createActionType("ADD_USEFUL_LINK_GROUP");
export const GET_USEFUL_LINK_GROUPS = createActionType(
  "GET_USEFUL_LINK_GROUPS"
);
export const GET_USEFUL_LINK_GROUP_BY_ID = createActionType(
  "GET_USEFUL_LINKS_GROUP_BY_ID"
);
export const EDIT_USEFUL_LINK_GROUP_BY_ID = createActionType(
  "EDIT_USEFUL_LINK_GROUP_BY_ID"
);
export const REMOVE_USEFUL_LINK_GROUP_BY_ID = createActionType(
  "REMOVE_USEFUL_LINK_GROUP_BY_ID"
);

export const addUsefulLinkGroup = (data: any) =>
  createAsyncAction(
    ADD_USEFUL_LINK_GROUP,
    "/useful_links/add_useful_link_group",
    "post",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getUsefulLinkGroup = () =>
  createAsyncAction(
    GET_USEFUL_LINK_GROUPS,
    "/useful_links/get_useful_link_groups",
    "get",
    undefined
  );

export const getUsefulLinkGroupById = (id: any) =>
  createAsyncAction(
    GET_USEFUL_LINK_GROUP_BY_ID,
    `/useful_links/get_useful_link_group_by_id/${id}`,
    "get",
    undefined
  );

export const editUsefulLinkGroup = (id: any, data: any) =>
  createAsyncAction(
    EDIT_USEFUL_LINK_GROUP_BY_ID,
    `/useful_links/edit_useful_link_group_by_id/${id}`,
    "put",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeUsefulLinkGroup = (data: any) =>
  createAsyncAction(
    REMOVE_USEFUL_LINK_GROUP_BY_ID,
    `/useful_links/remove_useful_link_group_by_id/${data}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
